export enum FailedRequestType {
    StopCompletion = 'StopCompletion',
    SendAppState = 'SendAppState',
    ImageUpload = 'ImageUpload',
    BlobStorageUpload = 'BlobStorageUpload'
}